<template>
  <div>
    <div class="container fr-aic fr-jcsb">
      <el-button @click="showNewRuleForm = true" size="mini" type="primary">添加分店</el-button>
      <span style="color:#999999;">您可在右上角切换店铺</span>
    </div>
    <div class="container">
      <el-table :data="list">
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="分店名">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="地址">
          <template slot-scope="scope">
            <span>{{ scope.row.storeaddress }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.createdat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.fromstoreid === 0" v-if="scope.row.closed === 1" @click="close(scope.row)" size="small" type="text">关店</el-button>
            <el-button :disabled="scope.row.fromstoreid === 0" v-if="scope.row.closed === 2" @click="open(scope.row)" size="small" type="text">开启</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--  编辑分类弹框 -->
    <el-dialog :visible.sync="showNewRuleForm" title="分店" width="500px">
      <el-form label-width="50px" ref="form" label-position="left" size="small">
        <el-form-item label="分店">
          <el-row>
            <el-col span="8">
              <el-input placeholder="分店名" v-model="store.name"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div class="dialog-footer fr-jcfs" slot="footer">
        <el-button @click="onSubmit" size="small" type="primary">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../components/tab/index.vue';
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      list: [],
      store: {},
      showNewRuleForm: false,
      token: ''
    };
  },
  created() {
    this.token = getToken();
    this.getList();
  },
  methods: {
    async getList() {
      const res = await rpc('StoreAuthService.GetBranchStoreList', M('Token', { token: this.token }));
      this.list = res.storelistList;
    },

    open(row) {
      row = JSON.parse(JSON.stringify(row));
      rpc(
        'StoreAuthService.OpenOrCloseBranchStore',
        M('OpenOrCloseBranchStoreRequest', {
          token: M('Token', { token: this.token }),
          storeid: row.id,
          closed: 1
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },
    close(row) {
      row = JSON.parse(JSON.stringify(row));
      rpc(
        'StoreAuthService.OpenOrCloseBranchStore',
        M('OpenOrCloseBranchStoreRequest', {
          token: M('Token', { token: this.token }),
          storeid: row.id,
          closed: 2
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },

    onSubmit() {
      const row = JSON.parse(JSON.stringify(this.store));
      rpc(
        'StoreAuthService.CreateBranchStore',
        M('NewStoreRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', row)
        })
      ).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        location.reload();
      });
    }
  }
};
</script>

<style></style>
